<template>
    <div>
        <dynamic-toolbar
            title="Maintenance Reports"
            :loading="loading.lists"
            color="indigo"
            icon="mdi-chart-bar"
            theme="dark"
        >
            <template #buttons>
                <v-btn
                    color="blue"
                    depressed
                    large
                    dark
                    :to="'/maintenance/invoices'"
                >
                    <v-icon left>mdi-invoice-list</v-icon>
                    Invoices
                </v-btn>
            </template>
        </dynamic-toolbar>
        <v-card outlined>
            <v-card-text>
                <v-row style="margin-top: 5px;">
                    <v-col cols="12" md="2">
                        <v-text-field
                            v-model="formattedDateRangeTotalCost"
                            label="Total Cost"
                            hide-details
                            readonly
                            outlined
                            dense
                            :disabled="loading.dateRangeTotalCost"
                            ><template
                                v-if="loading.dateRangeTotalCost"
                            >
                                <v-icon
                                    slot="append"
                                    color="green"
                                    size="24"
                                    >mdi-loading mdi-spin</v-icon
                                >
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu
                            v-model="dateMenu.startDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="startDate"
                                    label="Start Date"
                                    prepend-inner-icon="mdi-calendar"
                                    single-line
                                    placeholder="YYYY-MM-DD"
                                    v-mask="'####-##-##'"
                                    outlined
                                    hint="Select the start date"
                                    persistent-hint
                                    dense
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="startDate"
                                no-title
                                @input="dateMenu.startDate = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu
                            v-model="dateMenu.endDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="endDate"
                                    label="End Date"
                                    prepend-inner-icon="mdi-calendar"
                                    single-line
                                    placeholder="YYYY-MM-DD"
                                    v-mask="'####-##-##'"
                                    outlined
                                    hint="Select the end date"
                                    persistent-hint
                                    dense
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="endDate"
                                no-title
                                @input="dateMenu.endDate = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <!-- <v-col cols="12" md="2">
                        <v-text-field
                            v-model="startDate"
                            label="Start Date"
                            hide-details
                            dense
                            prepend-icon="mdi-calendar"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            v-model="endDate"
                            label="End Date"
                            hide-details
                            dense
                            prepend-icon="mdi-calendar"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                        ></v-text-field>
                    </v-col> -->
                    <!--<v-col cols="12" md="2">
                        <date-range-menu
                            label="Date Range"
                            hint="Select a date range"
                            color="indigo"
                            @update:dateRange="dateRange = $event"
                        ></date-range-menu>
                    </v-col>-->
                    <v-col cols="12" md="2">
                        <v-select
                            v-show="startDate != '' && endDate != ''"
                            v-model="invoiceType"
                            :items="invoiceTypes"
                            item-text="text"
                            item-value="value"
                            label="Invoice Type"
                            prepend-inner-icon="mdi-file-chart"
                            dense
                            outlined
                            hint="Select the invoice type"
                            persistent-hint
                        ></v-select>
                    </v-col>
                    <!--Trailer/Truck autocomplete field-->
                    <v-col cols="12" md="2" v-show="invoiceType">
                        <v-autocomplete
                            v-if="invoiceType == 'trailer'"
                            v-model="trailer"
                            :items="trailers"
                            item-text="Trailer"
                            item-value="TrailerId"
                            label="Trailer"
                            prepend-icon="mdi-truck-trailer"
                            dense
                        >
                            <!--Show "total_cost"-->
                            <template v-slot:selection="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.Trailer }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Total Cost:
                                        {{ item.TrailerId }} -
                                        {{ item.total_cost }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>

                            <!--Show "total_cost" in the list-->
                            <template v-slot:item="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.Trailer }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Total Cost:
                                        {{ item.TrailerId }} -
                                        {{ item.total_cost }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-if="invoiceType == 'truck'"
                            v-model="truck"
                            :items="trucks"
                            item-text="Truck"
                            item-value="TruckID"
                            label="Truck"
                            prepend-icon="mdi-truck"
                            dense
                        ></v-autocomplete>
                    </v-col>
                </v-row>

                <!--Autocomplete fields based on invoice type
                        - Trailer
                        - Truck
                        - (Supply doesn't have autocomplete fields)
                        -->

                <!--Autocomplete fields for:
                        - TaxRegion
                        - Vendor
                        - Company
                        - Region
                        -->

                <!-- Checkbox for:
                          (Trailer and Truck)
                          - is_service_call
                          - is_incident
                          - is_oo_charge
                        -->
                <v-row>
                    <v-col cols="12" md="2">
                        <v-autocomplete
                            v-model="taxRegion"
                            :items="taxRegions"
                            item-text="name"
                            item-value="id"
                            label="Tax Region"
                            prepend-inner-icon="mdi-map-marker"
                            clearable
                            dense
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-autocomplete
                            v-model="vendor"
                            :items="vendors"
                            item-text="name"
                            item-value="id"
                            label="Vendor"
                            prepend-inner-icon="mdi-account"
                            clearable
                            dense
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-autocomplete
                            v-model="company"
                            :items="companies"
                            item-text="CompanyName"
                            item-value="CompanyID"
                            label="Company"
                            prepend-inner-icon="mdi-account-group"
                            clearable
                            dense
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-autocomplete
                            v-model="region"
                            :items="regions"
                            item-text="PrincipalRegion"
                            item-value="PrincipalRegionID"
                            label="Region"
                            prepend-inner-icon="mdi-map-marker"
                            clearable
                            dense
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <!-- Category and subcategory-->
                    <v-col cols="12" md="2">
                        <v-select
                            v-model="category"
                            :items="expenseCategoriesFiltered"
                            item-text="name"
                            item-value="id"
                            label="Category"
                            clearable
                            prepend-inner-icon="mdi-tag"
                            dense
                            @change="expenseSubCategoriesFilteredByCategory(category)"
                            outlined
                            :disabled="invoiceType == 'all'"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-select
                            v-model="subcategory"
                            :items="expenseSubCategoriesFiltered"
                            item-text="name"
                            item-value="id"
                            label="Subcategory"
                            clearable
                            prepend-inner-icon="mdi-tag"
                            dense
                            outlined
                            :disabled="invoiceType == 'all'"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="2">
                        <v-checkbox
                            v-model="isServiceCall"
                            label="Service Call"
                            prepend-icon="mdi-wrench"
                            indeterminate
                            dense
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-checkbox
                            v-model="isIncident"
                            label="Incident"
                            prepend-icon="mdi-alert"
                            indeterminate
                            dense
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-checkbox
                            v-model="isOOCharge"
                            label="Owner Operator Charge"
                            prepend-icon="mdi-cash"
                            indeterminate
                            dense
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12" justify="center">
                        <v-btn
                            color="primary"
                            depressed
                            dark
                            @click="getReports"
                        >
                            <v-icon left>mdi-file-chart</v-icon>
                            Generate Report
                        </v-btn>
                        <v-btn
                            class="ml-4"
                            color="success"
                            depressed
                            dark
                            @click="getInvoiceReportByDateRangeByAll()"
                        >
                            <v-icon left>mdi-calendar-text-outline</v-icon>
                            Get Invoice Report By Date Range
                        </v-btn>
                        <v-menu
                            transition="slide-x-transition"
                            bottom
                            right
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="ml-4"
                                    color="red darken-3"
                                    depressed
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon left>mdi-finance</v-icon>
                                    Get Rolling 12 Trailer Stats
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(report, i) in rolling12.trailerReports"
                                    :key="i"
                                    @click="getRolling12(report)"
                                    dense
                                    small
                                >
                                    <v-list-item-title>{{ report.name }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <!-- <v-btn
                            class="ml-4"
                            color="indigo"
                            depressed
                            dark
                            @click="getPurchaseOrders"
                        >
                            <v-icon left>mdi-shopping-search</v-icon>
                            Get Purchase Orders
                        </v-btn> -->
                        <!-- <v-btn
                            color="primary"
                            depressed
                            small
                            dark
                            @click="getStockReport"
                            class="ml-2"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Generate Stock Report
                        </v-btn> -->
                        <!--Trailer Annual Expenses-->
                        <!-- <v-btn
                            color="success"
                            depressed
                            small
                            dark
                            @click="downloadAnnualSpending"
                            class="ml-2"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Trailer Monthly Expenses
                        </v-btn> -->
                        <!--Trailer Annual Expenses by Category-->
                        <!-- <v-btn
                            color="success"
                            depressed
                            small
                            dark
                            @click="downloadAnnualSpendingByCategory"
                            class="ml-2"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Trailer Annual Expenses by Category
                        </v-btn> -->
                    </v-col>
                </v-row>
                <v-card outlined style="margin: 25px 0 15px;" v-if="showTable">
                    <v-card-title
                        class="text-h5 mb-2"
                        style="padding-top: 25px;"
                    >
                        Invoices
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            depressed
                            small
                            dark
                            @click="downloadInvoiceReport('xlsx')"
                            outlined
                            style="margin-right: 35px;"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Invoice Report
                        </v-btn>
                        <v-text-field
                            v-model="search.invoice"
                            append-icon="mdi-magnify"
                            label="Search invoice"
                            hide-details
                            style="padding-top: 0;margin-top: 0;"
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="reportHeaders.Main"
                        :items="report"
                        :items-per-page="10"
                        class="elevation-1"
                        dense
                        single-expand
                        show-expand
                        :expanded.sync="expanded"
                        :search="search.invoice"
                    >
                        <template 
                            v-if="invoiceType == 'all'"
                            v-slot:item.invoice_type="{ item }"
                        >
                            <v-chip
                                small
                                :color="
                                    item.invoice_type == 'Trailer' ? 'primary' :
                                    item.invoice_type == 'Truck' ? 'indigo' :
                                    item.invoice_type == 'Supply' ? 'warning' :
                                    'mdi-invoice'
                                "
                                text-color="white"
                            >
                                {{ item.invoice_type }}
                            <v-icon right>
                                {{ 
                                    item.invoice_type == 'Trailer' ? 'mdi-train-car-tank' :
                                    item.invoice_type == 'Truck' ? 'mdi-truck-flatbed' :
                                    item.invoice_type == 'Supply' ? 'mdi-package-variant-closed' :
                                    'mdi-invoice'
                                }}
                            </v-icon>
                            </v-chip>
                        </template>
                        <template 
                            v-if="invoiceType == 'all'"
                            v-slot:item.model="{ item }"
                        >
                            {{ getUnit(item) }}
                        </template>
                        <template 
                            v-slot:item.invoice_issued_at="{ item }"
                        >
                            {{ formatDatetime(item.invoice_issued_at) }}
                        </template>
                        <template
                            v-slot:item.subtotal_cost="{ item }"
                        >
                            {{ getFormattedCurrencyField(item.subtotal_cost) }}
                        </template>
                        <template
                            v-slot:item.total_cost="{ item }"
                        >
                            {{ getFormattedCurrencyField(item.total_cost) }}
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="indigo lighten-1">
                                <v-card
                                    outlined
                                    style="margin: 15px 0 15px;"
                                >
                                    <v-card-title class="text-h5 mb-2">Details</v-card-title>
                                    <v-card-text style="display: flex;">
                                        <v-chip
                                            class="ma-2"
                                            :color="
                                                item.details.is_service_call
                                                    ? 'success'
                                                    : 'error'
                                            "
                                            text-color="white"
                                        >
                                            <v-avatar left>
                                                <v-icon
                                                    v-if="
                                                        item.details
                                                            .is_service_call
                                                    "
                                                >
                                                    mdi-checkbox-marked-circle
                                                </v-icon>
                                                <v-icon v-else>
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-avatar>
                                            ServiceCall
                                        </v-chip>
                                        <v-chip
                                            class="ma-2"
                                            :color="
                                                item.details.is_incident
                                                    ? 'success'
                                                    : 'error'
                                            "
                                            text-color="white"
                                        >
                                            <v-avatar left>
                                                <v-icon
                                                    v-if="
                                                        item.details.is_incident
                                                    "
                                                >
                                                    mdi-checkbox-marked-circle
                                                </v-icon>
                                                <v-icon v-else>
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-avatar>
                                            Incident
                                        </v-chip>
                                        <v-chip
                                            v-if="item.details.incident_number"
                                            class="ma-2"
                                            color="success"
                                            outlined
                                        >
                                            <v-avatar left>
                                                <v-icon>
                                                    mdi-pound-box
                                                </v-icon>
                                            </v-avatar>
                                            IncidentNum:
                                            {{ item.details.incident_number }}
                                        </v-chip>
                                        <v-chip
                                            class="ma-2"
                                            :color="
                                                item.details.is_oo_charge
                                                    ? 'success'
                                                    : 'error'
                                            "
                                            text-color="white"
                                        >
                                            <v-avatar left>
                                                <v-icon
                                                    v-if="
                                                        item.details
                                                            .is_oo_charge
                                                    "
                                                >
                                                    mdi-checkbox-marked-circle
                                                </v-icon>
                                                <v-icon v-else>
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-avatar>
                                            OOCharge
                                        </v-chip>
                                        <v-card
                                            outlined
                                            v-if="item.details.description"
                                            class="mt-4"
                                        >
                                            <v-card-title class="text-h6 mb-1"
                                                >Description</v-card-title
                                            >
                                            <v-card-text
                                                class="font-weight-regular grey--text"
                                            >
                                                {{ item.details.description }}
                                            </v-card-text>
                                        </v-card>
                                    </v-card-text>
                                </v-card>

                                <v-card outlined style="margin-bottom: 15px;">
                                    <v-card-title
                                        class="text-h5 mb-2"
                                        style="padding-top: 25px;"
                                    >
                                        Expenses
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn
                                            color="primary"
                                            dark
                                            depressed
                                            dense
                                            small
                                            outlined
                                            style="margin-right: 35px;"
                                            @click="downloadInvoiceReport(item.expenses)"
                                        >
                                            <v-icon left>mdi-file-excel</v-icon>
                                            Download Expense Report
                                        </v-btn> -->
                                        <v-text-field
                                            v-model="search.expense"
                                            append-icon="mdi-magnify"
                                            label="Search expense"
                                            hide-details
                                            style="padding-top: 0;margin-top: 0;"
                                        ></v-text-field>
                                    </v-card-title>
                                    <v-data-table
                                        :headers="reportHeaders.Exp"
                                        :items="item.expenses"
                                        group-by="maintenance_expense_type_id"
                                        item-key="id"
                                        class="elevation-1"
                                        hide-default-footer
                                        dense
                                        :search="search.expense"
                                    >
                                        <template
                                            v-slot:item.unit_cost="{ item }"
                                        >
                                            {{ getFormattedCurrencyField(item.unit_cost) }}
                                        </template>
                                        <template
                                            v-slot:item.subtotal_cost="{ item }"
                                        >
                                            {{ getFormattedCurrencyField(item.subtotal_cost) }}
                                        </template>
                                        <template
                                            v-slot:item.tax="{ item }"
                                        >
                                            {{ getFormattedCurrencyField(item.tax) }}
                                        </template>
                                        <template
                                            v-slot:item.total_cost="{ item }"
                                        >
                                            {{ getFormattedCurrencyField(item.total_cost) }}
                                        </template>
                                        <template
                                            v-slot:group.header="{
                                                items,
                                                isOpen,
                                                toggle
                                            }"
                                            style="cursor: crosshair; background-color: #e8eaf6"
                                        >
                                            <td :colspan="headers.length" class="text-left font-weight-bold">
                                                <v-btn
                                                    text
                                                    plain
                                                    left
                                                    color="indigo"
                                                    @click="toggle"
                                                >
                                                    <v-icon>
                                                        {{
                                                            isOpen
                                                                ? 'mdi-minus'
                                                                : 'mdi-plus'
                                                        }}</v-icon
                                                    >
                                                    {{ items[0].type.name }}
                                                </v-btn>
                                            </td>
                                        </template>
                                        <template slot="body.append">
                                            <tr>
                                                <td colspan="4"></td>
                                                <td class="text-left font-weight-bold">
                                                    <strong class="text-left font-weight-bold">
                                                        {{ getTotalByField(item.expenses, 'subtotal_cost', 'currency') }}
                                                    </strong>
                                                </td>
                                                <td class="text-left font-weight-bold">
                                                    <strong class="text-left font-weight-bold">
                                                        {{ getTotalByField(item.expenses, 'tax', 'currency') }}
                                                    </strong>
                                                </td>
                                                <td class="text-left font-weight-bold">
                                                    <strong class="text-left font-weight-bold">
                                                        {{ getTotalByField(item.expenses, 'total_cost', 'currency') }}
                                                    </strong>
                                                </td>
                                                <td colspan="3"></td>
                                            </tr>
                                        </template>
                                        <!-- <template v-slot:foot>
                                            <div class="ma-4">
                                                <v-text-field
                                                    v-model="
                                                        expenseTotals(item.expenses)
                                                            .subtotalCost
                                                    "
                                                    label="Subtotal Cost"
                                                    dense
                                                    readonly
                                                ></v-text-field>
                                                <v-text-field
                                                    v-model="
                                                        expenseTotals(item.expenses)
                                                            .totalTax
                                                    "
                                                    label="Total Tax"
                                                    dense
                                                    readonly
                                                ></v-text-field>
                                                <v-text-field
                                                    v-model="
                                                        expenseTotals(item.expenses)
                                                            .totalCost
                                                    "
                                                    label="Total Cost"
                                                    dense
                                                    readonly
                                                ></v-text-field>
                                            </div>
                                        </template> -->
                                    </v-data-table>
                                </v-card>
                            </td>
                        </template>
                        <template slot="body.append">
                            <tr>
                                <td :colspan="reportHeaders.Main.length-1"></td>
                                <td class="text-left font-weight-bold">
                                    <strong class="text-left font-weight-bold">
                                        {{ getTotalByField(report, 'subtotal_cost', 'currency') }}
                                    </strong>
                                </td class="text-left font-weight-bold">
                                <td>
                                    <strong class="text-left font-weight-bold">
                                        {{ getTotalByField(report, 'total_cost', 'currency') }}
                                    </strong>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>

                <v-card outlined style="margin: 25px 0 15px;" v-if="rolling12Ctx.Show">
                    <v-card-title class="text-h5 mb-2" style="padding-top: 25px;">
                        <v-spacer></v-spacer>
                        <v-row style="justify-content: flex-end;">
                            <v-col cols="auto" v-if="rolling12Ctx.Totals.includes('TotalHrsUse')" style="margin: 10px;padding: 0;">
                                <v-text-field
                                    v-model="formattedTotalHrsUse"
                                    label="TotalHrsUse"
                                    readonly
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="auto" v-if="rolling12Ctx.Totals.includes('OdometerKM')" style="margin: 10px;padding: 0;">
                                <v-text-field
                                    v-model="formattedOdometerKM"
                                    label="OdometerKM"
                                    readonly
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="auto" v-if="rolling12Ctx.Totals.includes('MaintExpenses')" style="margin: 10px;padding: 0;">
                                <v-text-field
                                    v-model="formattedMaintExpenses"
                                    label="MaintExpenses"
                                    readonly
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="auto" v-if="rolling12Ctx.Totals.includes('CostPerKM')" style="margin: 10px;padding: 0;">
                                <v-text-field
                                    v-model="formattedCostPerKM"
                                    label="CostPerKM"
                                    readonly
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-title class="text-h5 mb-2" style="padding-top: 10px;">
                        {{ rolling12Ctx.Name }} / {{ rolling12Ctx.CurrentPath }}
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="rolling12Ctx.LastItems.length"
                            color="indigo"
                            depressed
                            small
                            dark
                            @click="handlePreviousLevel"
                            outlined
                            style="margin-right: 35px;"
                        >
                            <v-icon left>mdi-arrow-left</v-icon>
                            Go back
                        </v-btn>
                        <v-btn
                            v-if="getCurrentView('ByTrailer')"
                            color="success"
                            depressed
                            small
                            dark
                            @click="downloadR12"
                            outlined
                            style="margin-right: 35px;"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Report
                        </v-btn>
                        <v-text-field
                            v-model="search.r12"
                            append-icon="mdi-magnify"
                            label="Search here"
                            hide-details
                            style="padding-top: 0;margin-top: 0;"
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="rolling12Ctx.Headers"
                        :items="rolling12Ctx.Items"
                        class="elevation-1"
                        dense
                        :search="search.r12"
                    >
                        <template
                            v-if="getCurrentView('ByTrailer') && getReportAlias('R12-Trailer-View-By-Trailer-By-Month')"
                            v-slot:item.Trailer="{ item }"
                        >
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        style="margin: 1px 0;"
                                        outlined
                                        color="indigo"
                                        small
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="goToInvoiceAnalysis(item)"
                                    >
                                        {{ item.Trailer }}
                                    </v-btn>
                                </template>
                                <div v-if="Object.keys(item.Details).length">
                                    <p
                                        v-for="key in Object.keys(item.Details)"
                                        :key="key"
                                        style="margin: 0 0 4px;padding: 0;"
                                    >
                                        <span>{{ key }}: </span>
                                        <span>{{ item.Details[key] }} </span>
                                    </p>
                                </div>
                            </v-tooltip>
                        </template>
                        <template
                            v-else-if="getCurrentView('ByTrailer') && getReportAlias('R12-Trailer-View-By-Trailer-By-Month', true)"
                            v-slot:item.Trailer="{ item }"
                        >
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        style="margin: 1px 0;"
                                        outlined
                                        color="indigo"
                                        small
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="handleNextLevel(item)"
                                    >
                                        {{ item.Trailer }}
                                    </v-btn>
                                </template>
                                <div v-if="Object.keys(item.Details).length">
                                    <p
                                        v-for="key in Object.keys(item.Details)"
                                        :key="key"
                                        style="margin: 0 0 4px;padding: 0;"
                                    >
                                        <span>{{ key }}: </span>
                                        <span>{{ item.Details[key] }} </span>
                                    </p>
                                </div>
                            </v-tooltip>
                        </template>
                        <template
                            v-else-if="getCurrentView('ByMonth')"
                            v-slot:item.Month="{ item }"
                        >
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                        style="margin: 1px 0;"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        {{ item.Month }}
                                    </span>
                                </template>
                                <div v-if="Object.keys(item.Details).length">
                                    <p
                                        v-for="key in Object.keys(item.Details)"
                                        :key="key"
                                        style="margin: 0 0 4px;padding: 0;"
                                    >
                                        <span>{{ key }}: </span>
                                        <span>{{ item.Details[key] }} </span>
                                    </p>
                                </div>
                            </v-tooltip>
                        </template>
                        <template
                            v-if="getCurrentView('ByRegion')"
                            v-slot:item.Region="{ item }"
                        >
                            <v-btn
                                style="margin: 1px 0;"
                                outlined
                                color="indigo"
                                small
                                dense
                                @click="handleNextLevel(item)"
                            >
                                {{ item.Region }}
                            </v-btn>
                        </template>
                        <template
                            v-if="getCurrentView('ByCategory')"
                            v-slot:item.Category="{ item }"
                        >
                            <v-btn
                                style="margin: 1px 0;"
                                outlined
                                color="indigo"
                                small
                                dense
                                @click="handleNextLevel(item)"
                            >
                                {{ item.Category }}
                            </v-btn>
                        </template>
                        <template
                            v-if="getCurrentView('ByTrailer') || getCurrentView('ByMonth')"
                            v-slot:item.GeotabOdoStart="{ item }"
                        >
                            <span
                                v-bind="attrs"
                                v-on="on"
                            >
                                {{ getFormattedNumberField(item.GeotabOdoStart, 0) }}
                            </span>
                        </template>
                        <template
                            v-if="getCurrentView('ByTrailer') || getCurrentView('ByMonth')"
                            v-slot:item.GeotabOdoEnd="{ item }"
                        >
                            <span
                                v-bind="attrs"
                                v-on="on"
                            >
                                {{ getFormattedNumberField(item.GeotabOdoEnd, 0) }}
                            </span>
                        </template>
                        <template
                            v-if="getCurrentView('ByTrailer')"
                            v-slot:item.TotalHrsUse="{ item }"
                        >
                            <span
                                v-bind="attrs"
                                v-on="on"
                            >
                                {{ getFormattedNumberField(item.TotalHrsUse, 0) }}
                            </span>
                        </template>
                        <template
                            v-slot:item.OdometerKM="{ item }"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        {{ getFormattedNumberField(item.OdometerKM, 0) }}
                                    </span>
                                </template>
                                <span>Calculation: OdoEnd - OdoStart</span>
                            </v-tooltip>
                        </template>
                        <template
                            v-slot:item.MaintExpenses="{ item }"
                        >
                            {{ getFormattedCurrencyField(item.MaintExpenses, 0) }}
                        </template>
                        <!-- <template
                            v-if="getCurrentView('ByRegion') || getCurrentView('ByCategory')"
                            v-slot:item.Subtotal="{ item }"
                        >
                            {{ getFormattedCurrencyField(item.Subtotal) }}
                        </template>
                        <template
                            v-if="getCurrentView('ByRegion') || getCurrentView('ByCategory')"
                            v-slot:item.TotalCost="{ item }"
                        >
                            {{ getFormattedCurrencyField(item.TotalCost) }}
                        </template> -->
                        <template
                            v-slot:item.CostPerKM="{ item }"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        {{ getFormattedCurrencyField(item.CostPerKM, 4) }}
                                    </span>
                                </template>
                                <span
                                    >Calculation: MaintExpenses /
                                    OdometerKM</span
                                >
                            </v-tooltip>
                        </template>
                        <template
                            slot="body.append"
                            v-if="rolling12Ctx.Totals.length"
                        >
                            <tr>
                                <template v-for="hd in rolling12Ctx.Headers">
                                    <td
                                        v-if="rolling12Ctx.Totals.includes(hd.value)"
                                        class="font-weight-bold text-left pr-12"
                                        style="font-size:14px;"
                                    >
                                        {{
                                            hd.value == 'OdometerKM' ? getTotalByField(rolling12Ctx.Items, hd.value, 'number', 0) :
                                            hd.value == 'CostPerKM' ? getCostPerKM() :
                                            hd.value == 'TotalHrsUse' ? getTotalByField(rolling12Ctx.Items, hd.value, 'number', 0) :
                                            getTotalByField(rolling12Ctx.Items, hd.value, 'currency', 0)
                                        }}
                                    </td>
                                    <td
                                        v-else
                                        class="font-weight-bold text-left pr-12"
                                        style="font-size:14px;"
                                    ></td>
                                </template>
                            </tr>
                        </template>
                        <template
                            slot="body.prepend"
                            v-if="rolling12Ctx.Totals.length"
                        >
                            <tr>
                                <template v-for="hd in rolling12Ctx.Headers">
                                    <td
                                        v-if="rolling12Ctx.Totals.includes(hd.value)"
                                        class="font-weight-bold text-left pr-12"
                                        style="font-size:14px;"
                                    >
                                        {{
                                            hd.value == 'OdometerKM' ? getTotalByField(rolling12Ctx.Items, hd.value, 'number') :
                                            hd.value == 'CostPerKM' ? getCostPerKM() :
                                            hd.value == 'TotalHrsUse' ? getTotalByField(rolling12Ctx.Items, hd.value, 'number', 0) :
                                            getTotalByField(rolling12Ctx.Items, hd.value, 'currency', 0)
                                        }}
                                    </td>
                                    <td
                                        v-else
                                        class="font-weight-bold text-left pr-12"
                                        style="font-size:14px;"
                                    ></td>
                                </template>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>

                <v-card outlined style="margin: 25px 0 15px;" v-if="purchaseOrders.Show">
                    <v-card-title class="text-h5 mb-2" style="padding-top: 30px;">
                        {{ purchaseOrders.Name }}
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            depressed
                            small
                            dark
                            @click="downloadPO"
                            outlined
                            style="margin-right: 35px;"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Report
                        </v-btn>
                        <v-text-field
                            v-model="search.po"
                            append-icon="mdi-magnify"
                            label="Search here"
                            hide-details
                            style="padding-top: 0;margin-top: 0;"
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="purchaseOrders.Headers.vue"
                        :items="purchaseOrders.Items"
                        class="elevation-1"
                        dense
                        :search="search.po"
                    >
                        <template
                            v-slot:item.PONumber="{ item }"
                        >
                            <v-tooltip right color="indigo">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        text
                                        small
                                        @click="copyToClipboard([item.PONumber, item.Description])"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        {{ item.PONumber }}
                                    </v-btn>
                                </template>
                                <span>{{ item.Description }}</span>
                            </v-tooltip>
                        </template>
                        <template
                            v-slot:item.KM="{ item }"
                        >
                            <span>
                                {{ getFormattedNumberField(item.KM, 0) }}
                            </span>
                        </template>
                        <template
                            v-slot:item.EstimatedCost="{ item }"
                        >
                            <span>
                                {{ item.EstimatedCost != null ? getFormattedCurrencyField(item.EstimatedCost, 0) : item.EstimatedCost }}
                            </span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
function logErr(error) {
    console.log(error);
}
import DateRangeMenu from '@/components/Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';

import { mask } from 'vue-the-mask';
import { sheets } from '@/Utils/dataSheets';
import { xlsxSheets } from '../../Utils/xlsxSheets';
import axios from 'axios';
export default {
    directives: { mask },
    name: 'MaintenanceReports',
    components: {
        DynamicToolbar,
        DateRangeMenu
    },
    data: () => ({
        auth: {},
        //Date range
        dateRange: '',
        dateRangeDisplay: '',
        dateRangeStart: '',
        dateRangeEnd: '',
        dateRangeTotalCost: '',
        dateType: 'invoice_issued_at',
        invoiceType: '',
        dateTypes: [
            { text: 'Invoice Date', value: 'invoice_issued_at' },
            { text: 'Created At', value: 'created_at' }
        ],
        invoiceTypes: [
            { text: 'Trailers', value: 'trailers', total_cost: 0 },
            { text: 'Trucks', value: 'trucks', total_cost: 0 },
            { text: 'Supplies', value: 'supplies', total_cost: 0 },
            { text: 'All', value: 'all', total_cost: 0, disabled: false }
        ],
        menu: false,

        //loaders
        loading: {
            lists: false,
            dateRangeTotalCost: false,
            report: false
        },

        //Axios data
        trailers: [],
        trucks: [],
        rentAgreements: [],
        expenseTypes: [],
        expenseCategories: [],
        expenseCategoriesFiltered: [],
        expenseSubCategories: [],
        expenseSubCategoriesFiltered: [],
        taxRegions: [],
        vendors: [],
        companies: [],
        regions: [],

        //Selected data
        trailer: '',
        truck: '',
        taxRegion: '',
        vendor: '',
        company: '',
        region: '',
        type: '',
        category: '',
        subcategory: '',
        isServiceCall: false,
        isIncident: false,
        isOOCharge: false,

        //Report data
        showTable: false,
        report: [],
        reportHeaders: {
            Main: [],
            Det: [],
            Exp: []
        },
        expanded: [],
        search: {
            expense: '',
            invoice: '',
            r12: '',
            po: ''
        },
        /*expenseHeaders: [
            {
                text: 'Expense Category',
                value: 'category.name'
            },
            {
                text: 'Expense Subcategory',
                value: 'subcategory.name'
            },
            { text: 'Quantity', value: 'quantity' },
            { text: 'Unit Cost', value: 'unit_cost' },
            { text: 'Subtotal Cost', value: 'subtotal_cost' },
            { text: 'Tax', value: 'tax' },
            { text: 'Total Cost', value: 'total_cost' },
            { text: 'Custom Tax Rate', value: 'custom_tax_rate' },
            { text: 'Description', value: 'description' },
            { text: 'Comments', value: 'comments' }
        ]*/

        startDate: "",
        endDate: "",
        rolling12Ctx: {
            Show: false,
            Items: [],
            Headers: [],
            Totals: [],
            DateRange: [],
            CurrentView: '',
            MemoryHeaders: [],
            MemoryTotals: [],
            MemoryItems: [],
            LastItems: [],
            ExcelHeaders: [],
            ReportAlias: '',
            Name: '',
            Filename: '',
            RegionId: '',
            CurrentPath: '',
        },
        rolling12: { // flag
            trailerReports: [
                {
                    id: 1,
                    name: 'View By Trailer',
                    alias: 'R12-View-By-Trailer',
                    axios: '/v2/maintenance/reports/rolling-12/trailer/by-trailer',
                },
                {
                    id: 2,
                    name: 'View By Category',
                    alias: 'R12-View-By-Category',
                    axios: '/v2/maintenance/reports/rolling-12/trailer/by-category',
                },
                {
                    id: 3,
                    name: 'View By Region By Category',
                    alias: 'R12-View-By-Region-By-Category',
                    axios: '/v2/maintenance/reports/rolling-12/trailer/by-region-by-category',
                },
                {
                    id: 4,
                    name: 'View By Region By Trailer',
                    alias: 'R12-View-By-Region-By-Trailer',
                    axios: '/v2/maintenance/reports/rolling-12/trailer/by-region-by-trailer',
                },
                // {
                //     id: 5,
                //     name: 'View By Trailer By Month',
                //     alias: 'R12-Trailer-View-By-Trailer-By-Month',
                //     axios: '/v2/maintenance/reports/rolling-12/trailer/by-trailer-by-month',
                // },
            ]
        },
        purchaseOrders: {
            Show: false,
            Name: '',
            Headers: {
                vue: [],
                excel: []
            },
            Items: []
        },
        dateMenu: {
            startDate: false,
            endDate: false,
        },
    }),
    mounted() {
        this.dateRangeDisplay = 'Select a date range';
        this.authentication = {
            headers: {
                Authorization: 'Bearer ' + this.$store.state.token
            }
        };
        this.getReportData();
        //Issue a setSnackbar toast to instruct the user to select a date range
        this.$store.dispatch('setSnackbar', {
            color: 'info',
            text: 'Please select a date range',
            timeout: 5000,
            elevation: 24
        });
    },
    computed: {
        formattedDateRangeTotalCost: {
            get() {
                return this.getFormattedCurrencyField(this.dateRangeTotalCost);
            },
        },
        formattedTotalHrsUse: {
            get() {
                return this.getTotalByField(this.rolling12Ctx.Items, 'TotalHrsUse', 'number', 0);
            },
        },
        formattedOdometerKM: {
            get() {
                return this.getTotalByField(this.rolling12Ctx.Items, 'OdometerKM', 'number', 0);
            },
        },
        formattedMaintExpenses: {
            get() {
                return this.getTotalByField(this.rolling12Ctx.Items, 'MaintExpenses', 'currency', 0);
            },
        },
        formattedCostPerKM: {
            get() {
                return this.getCostPerKM();
            },
        },
    },
    methods: {
        setDateRange() {
            let dateRange = this.dateRange;
            if (dateRange == '') {
                this.dateRangeStart = '';
                this.dateRangeEnd = '';
            } else {
                //If the end date is less than the start date, swap them
                if (dateRange[1] < dateRange[0]) {
                    let temp = dateRange[0];
                    dateRange[0] = dateRange[1];
                    dateRange[1] = temp;
                }
                this.dateRangeStart = dateRange[0];
                this.dateRangeEnd = dateRange[1];
            }
            this.dateRangeDisplay = `${this.dateRangeStart} ~ ${this.dateRangeEnd}`;
        },

        expenseCategoriesFilteredByType(expenseType) {
            if (!expenseType) return [];
            console.log('Expense type: ', expenseType);
            console.log('Expense categories: ', this.expenseCategories);
            this.expenseCategoriesFiltered = this.expenseCategories.filter(
                expenseCategory =>
                    expenseCategory.maintenance_expense_type_id ==
                    expenseType.id
            );
            console.log(
                'Filtered categories: ',
                this.expenseCategoriesFiltered
            );
        },

        expenseSubCategoriesFilteredByCategory(expenseCategoryId) {
            if (!expenseCategoryId) {
                this.expenseSubCategoriesFiltered = [];
                return [];
            }
            console.log('Expense category: ', expenseCategoryId);
            console.log('Expense subcategories: ', this.expenseSubCategories);
            this.expenseSubCategoriesFiltered = this.expenseSubCategories.filter(
                expenseSubcategory =>
                    expenseSubcategory.maintenance_expense_category_id ==
                    expenseCategoryId
            );
            console.log(
                'Filtered subcategories: ',
                this.expenseSubCategoriesFiltered
            );
        },
        getCostPerKM(format = true) {
            const maintExpenses = this.getTotalByField(this.rolling12Ctx.Items, 'MaintExpenses');
            const odometerKM = this.getTotalByField(this.rolling12Ctx.Items, 'OdometerKM');
            const costPerKM = maintExpenses / odometerKM;

            if (format) return this.getFormattedCurrencyField(costPerKM, 4);
            else return costPerKM.toFixed(4);
        },
        getTotalByField(source, field, format = '', decimals = 2) {
            let total = source.reduce((acc, curr) => {
                let value = parseFloat(curr[field]);
                return acc + (!isNaN(value) ? value : 0);
            }, 0);
            total = total.toFixed(decimals);

            if (format == 'currency') total = this.getFormattedCurrencyField(total, decimals);
            else if (format == 'number') total = this.getFormattedNumberField(total, decimals);

            return total;
        },
        getFormattedCurrencyField(value, decimals = 2) {
            let cad = new Intl.NumberFormat('en-CA', {
                style: 'currency',
                currency: 'CAD',
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            });
            return cad.format(value);
        },
        getFormattedNumberField(value, decimalPlaces = 2) {
            const number = parseFloat(value);
            return number.toLocaleString('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            });
        },
        formatDatetime(datetime) {
            let parts = datetime.split(' ');
            return parts[0];
        },
        expenseTotals(expenses) {
            //Return total costs and taxes for the expenses
            let totalCost = 0;
            let totalTax = 0;
            console.log(expenses);
            expenses.forEach(expense => {
                //values are in text format, convert to numbers of no more than 2 decimal places, remember that these are currencies
                let cost = parseFloat(expense.total_cost);
                let tax = parseFloat(expense.tax);
                console.log(cost, tax);
                totalCost += cost;
                totalTax += tax;
            });
            totalCost = Math.round(totalCost * 100) / 100;
            totalTax = Math.round(totalTax * 100) / 100;
            console.log(totalCost, totalTax);
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            });

            return {
                subtotalCost: formatter.format(totalCost - totalTax),
                totalCost: formatter.format(totalCost),
                totalTax: formatter.format(totalTax)
            };
        },
        getDateRangeTotalCost() {
            let url = '';
            if (this.startDate == '' || this.endDate == '') {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date range'
                });
                return;
            }

            url =
                '/v2/maintenance/reports/total-cost-by-dates/' +
                this.startDate +
                '/' +
                this.endDate;

            this.loading.dateRangeTotalCost = true;
            axios
                .get(url, this.authentication)
                .then(response => {
                    this.dateRangeTotalCost = response.data.total;
                    //Set the total cost for each invoice type
                    this.invoiceTypes.forEach(invoiceType => {
                        invoiceType.total_cost =
                            response.data[invoiceType.value];
                    });
                    this.loading.dateRangeTotalCost = false;
                })
                .catch(error => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Error getting report data' + error
                    });
                });
        },
        getEquipmentByCost() {
            let invoiceType = this.invoiceType;
            if (invoiceType == 'supply') return;
            let dateRange = this.dateRange;
            let url = '';
            let startDate = dateRange[0];
            let endDate = dateRange[1];
            url =
                '/v2/maintenance/reports/equipment-cost-by-dates/' +
                invoiceType + //truck or trailer
                '/' +
                startDate +
                '/' +
                endDate;

            this.loading.equipmentByCost = true;
            axios
                .get(url, this.authentication)
                .then(response => {
                    if (invoiceType == 'trailer') {
                        // returns an array of trailers with their total cost "model_id" and "total_cost"
                        for (let i = 0; i < response.data.length; i++) {
                            let trailer = response.data[i];
                            let trailerId = trailer.model_id;
                            let totalCost = trailer.total_cost;
                            let trailerIndex = this.trailers.findIndex(
                                trailer => trailer.TrailerId == trailerId
                            );
                            this.trailers[trailerIndex].total_cost = totalCost;
                            console.log(
                                'Trailer: ',
                                this.trailers[trailerIndex],
                                'Index: ',
                                trailerIndex
                            );
                        }
                        //Sort the trailers by total cost
                        this.trailers.sort((a, b) => {
                            return b.total_cost - a.total_cost;
                        });
                    } else if (invoiceType == 'truck') {
                        // returns an array of trucks with their total cost "model_id" and "total_cost"
                        for (let i = 0; i < response.data.length; i++) {
                            let truck = response.data[i];
                            let truckId = truck.model_id;
                            let totalCost = truck.total_cost;
                            let truckIndex = this.trucks.findIndex(
                                truck => truck.TruckID == truckId
                            );
                            this.trucks[truckIndex].total_cost = totalCost;
                        }
                    }
                    this.loading.equipmentByCost = false;
                })
                .catch(error => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Error getting report data' + error
                    });
                });
        },
        getReports() {
            // let dateRange = this.dateRange;
            let dateRange = [this.startDate, this.endDate];
            let dateType = this.dateType;
            let url = '';
            let params = {};

            this.rolling12Ctx.Show = false;
            console.log(dateRange);
            if (this.startDate == '' || this.endDate == '') {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date range'
                });
                return;
            }
            if (dateType == '') {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date type'
                });
                return;
            }
            if (this.invoiceType == 'trailers') {
                url = '/v2/maintenance/reports/trailers';
                //Only add the optional parameters if they are not empty
                params = {
                    dateRange: dateRange,
                    dateType: dateType,
                    trailer: this.trailer,
                    taxRegion: this.taxRegion,
                    vendor: this.vendor,
                    company: this.company,
                    region: this.region,
                    category: this.category,
                    subcategory: this.subcategory,
                    isServiceCall: this.isServiceCall,
                    isIncident: this.isIncident,
                    isOOCharge: this.isOOCharge
                };
            } else if (this.invoiceType == 'trucks') {
                url = '/v2/maintenance/reports/trucks';
                params = {
                    dateRange: dateRange,
                    dateType: dateType,
                    truck: this.truck,
                    taxRegion: this.taxRegion,
                    vendor: this.vendor,
                    company: this.company,
                    region: this.region,
                    category: this.category,
                    subcategory: this.subcategory,
                    isServiceCall: this.isServiceCall,
                    isIncident: this.isIncident,
                    isOOCharge: this.isOOCharge
                };
            } else if (this.invoiceType == 'supplies') {
                url = '/v2/maintenance/reports/supplies';
                params = {
                    dateRange: dateRange,
                    dateType: dateType,
                    taxRegion: this.taxRegion,
                    vendor: this.vendor,
                    company: this.company,
                    region: this.region,
                    category: this.category,
                    subcategory: this.subcategory
                };
            } else if (this.invoiceType == 'all') {
                url = '/v2/maintenance/reports/all';
                params = {
                    dateRange: dateRange,
                    dateType: dateType,
                    taxRegion: this.taxRegion,
                    vendor: this.vendor,
                    company: this.company,
                    region: this.region,
                };
            } else {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select an invoice type'
                });
                return;
            }
            console.log('URL: ', url);
            console.log('Params: ', params);
            this.$store.state.isLoading = true;
            this.showTable = false;
            //Insert the authentication header
            axios
                .get(url, {
                    params: params,
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('from getReports: ', response.data);
                    let invoices = response.data;
                    this.setInvoiceData(invoices);
                    this.setReportHeaders();
                    this.showTable = true;
                    this.$store.state.isLoading = false;
                    if (this.report.length == 0) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'warning',
                            text: 'No data found'
                        });
                    }
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Error getting report data' + error
                    });
                });
        },
        setInvoiceData(invoices) {
            this.report = [];

            if (
                this.invoiceType == 'trailers' ||
                this.invoiceType == 'trucks'
            ) {
                for (let inv of invoices) {
                    let data = {
                        id: inv.id,
                        invoice_number: inv.invoice_number,
                        invoice_issued_at: inv.invoice_issued_at,
                        mtype: inv.mtype,
                        model: inv.model,
                        purchase_order: inv.purchase_order,
                        region: inv.region,
                        tax_region: inv.tax_region,
                        vendor: inv.vendor,
                        company: inv.company,
                        subtotal_cost: inv.subtotal_cost,
                        total_cost: inv.total_cost,
                        details: {
                            is_service_call: inv.is_service_call,
                            is_incident: inv.is_incident,
                            incident_number: inv.incident_number,
                            is_oo_charge: inv.is_oo_charge,
                            description: inv.description
                        },
                        expenses: inv.expenses,
                    };

                    if (this.invoiceType == 'trucks') {
                        data.replacement_truck_id = inv.replacement_truck_id;
                        data.another_replacement_truck = inv.another_replacement_truck;
                        data.start_of_replacement_truck_use_at = inv.start_of_replacement_truck_use_at;
                        data.end_of_replacement_truck_use_at = inv.end_of_replacement_truck_use_at;
                    }

                    this.report.push(data);
                }
            } else if (this.invoiceType == 'supplies') {
                for (let inv of invoices) {
                    this.report.push({
                        id: inv.id,
                        invoice_number: inv.invoice_number,
                        invoice_issued_at: inv.invoice_issued_at,
                        purchase_order: inv.purchase_order,
                        region: inv.region,
                        tax_region: inv.tax_region,
                        vendor: inv.vendor,
                        company: inv.company,
                        subtotal_cost: inv.subtotal_cost,
                        total_cost: inv.total_cost,
                        details: {
                            is_service_call: inv.is_service_call,
                            is_incident: inv.is_incident,
                            is_oo_charge: inv.is_oo_charge,
                            description: inv.description
                        },
                        expenses: inv.expenses
                    });
                }
            } else if (this.invoiceType == 'all') {
                for (let inv of invoices) {
                    let data = {
                        id: inv.id,
                        invoice_number: inv.invoice_number,
                        invoice_issued_at: inv.invoice_issued_at,
                        mtype: inv.mtype,
                        model: inv.model,
                        purchase_order: inv.purchase_order,
                        region: inv.region,
                        tax_region: inv.tax_region,
                        vendor: inv.vendor,
                        company: inv.company,
                        subtotal_cost: inv.subtotal_cost,
                        total_cost: inv.total_cost,
                        details: {
                            is_service_call: inv.is_service_call,
                            is_incident: inv.is_incident,
                            incident_number: inv.incident_number,
                            is_oo_charge: inv.is_oo_charge,
                            description: inv.description,
                        },
                        expenses: inv.expenses,
                        replacement_truck_id: inv.replacement_truck_id,
                        another_replacement_truck: inv.another_replacement_truck,
                        start_of_replacement_truck_use_at: inv.start_of_replacement_truck_use_at,
                        end_of_replacement_truck_use_at: inv.end_of_replacement_truck_use_at,
                        invoice_type: inv.invoice_type,
                    };

                    this.report.push(data);
                }
            }
        },
        setReportHeaders() {
            this.reportHeaders = {
                Main: [
                    { text: 'InvoiceId', value: 'id' },
                    { text: 'InvoiceNum', value: 'invoice_number' },
                    { text: 'InvoiceDate', value: 'invoice_issued_at' },
                    {
                        text: 'PONum',
                        value: 'purchase_order.purchase_order_number'
                    },
                    { text: 'Region', value: 'region.PrincipalRegion' },
                    { text: 'TaxRegion', value: 'tax_region.name' },
                    { text: 'Vendor', value: 'vendor.name' },
                    { text: 'Company', value: 'company.CompanyName' },
                    { text: 'SubtotalCost', value: 'subtotal_cost' },
                    { text: 'TotalCost', value: 'total_cost' }
                ],
                Det: [
                    { text: 'ServiceCall', value: 'is_service_call' },
                    { text: 'Incident', value: 'is_incident' },
                    { text: 'IncidentNum', value: 'incident_number' },
                    { text: 'OOCharge', value: 'is_oo_charge' },
                    { text: 'Description', value: 'description' }
                ],
                Exp: [
                    { text: 'Category', value: 'category.name' },
                    { text: 'Subcategory', value: 'subcategory.name' },
                    { text: 'Quantity', value: 'quantity' },
                    { text: 'UnitCost', value: 'unit_cost' },
                    { text: 'SubtotalCost', value: 'subtotal_cost' },
                    { text: 'Tax', value: 'tax' },
                    { text: 'TotalCost', value: 'total_cost' },
                    { text: 'CustomTaxRate', value: 'custom_tax_rate' },
                    { text: 'Description', value: 'description' },
                    { text: 'Comments', value: 'comments' }
                ]
            };

            let invDateIdx = this.reportHeaders.Main.findIndex(
                hdr => hdr.value == 'invoice_issued_at'
            );
            let incNumIdx = this.reportHeaders.Det.findIndex(
                hdr => hdr.value == 'incident_number'
            );
            if (this.invoiceType == 'trailers') {
                this.reportHeaders.Main.splice(
                    invDateIdx + 1,
                    0,
                    { text: 'MaintType', value: 'mtype.name' },
                    { text: 'Trailer', value: 'model.Trailer' }
                );
            } else if (this.invoiceType == 'trucks') {
                this.reportHeaders.Main.splice(
                    invDateIdx + 1,
                    0,
                    { text: 'MaintType', value: 'mtype.name' },
                    { text: 'Truck', value: 'model.Truck' }
                );
            } else if (this.invoiceType == 'supplies') {
                this.reportHeaders.Det.splice(incNumIdx, 1);
            } else if (this.invoiceType == 'all') {
                this.reportHeaders.Main.splice(invDateIdx+1, 0, 
                    { text: 'InvoiceType', value: 'invoice_type' },
                    { text: 'MaintType', value: 'mtype.name' },
                    { text: 'Unit', value: 'model' },
                );
            }
        },
        getUnit(item) {
            if (item.model) {
                return item.model.Truck ? item.model.Truck : item.model.Trailer;
            }
            return 'n/a';
        },
        getLists() {
            axios
                .get('/v2/maintenance/collections/report', this.authentication)
                .then(response => {
                    this.trailers = response.data.trailers;
                    this.trucks = response.data.trucks;
                    this.expenseTypes = response.data.expenseTypes;
                    this.expenseCategories = response.data.expenseCategories;
                    this.expenseSubCategories =
                        response.data.expenseSubCategories;
                    this.taxRegions = response.data.taxRegions;
                    this.vendors = response.data.vendors;
                    this.companies = response.data.companies;
                    this.regions = response.data.regions;
                    this.loading.lists = false;

                    this.type = response.data.expenseTypes.find(
                        expenseType => expenseType.id == 1
                    );
                    this.expenseCategoriesFilteredByType(this.type);
                    this.regions.push({
                        PrincipalRegionID: 4,
                        PrincipalRegion: 'Missing data'
                    });
                })
                .catch(logErr);
        },
        async getReportData() {
            await this.getLists();
        },
        getReportFilename(requestType, reportAlias) {
            console.log(this.startDate, this.endDate);
            return (
                reportAlias +
                '_' +
                this.startDate +
                '_' +
                this.endDate +
                '.' +
                requestType
            );
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        downloadInvoiceReport(requestType) {
            console.log('Download Invoice Report: ', requestType);
            let str = this.$store;
            str.state.isLoading = true;
            // Set Report Alias
            let reportAlias =
                'InvoiceReport' +
                '_' +
                this.capitalizeFirstLetter(this.invoiceType);

            let params = {
                RequestType: requestType,
                Data: this.report,
                InvoiceType: this.invoiceType,
                ReportAlias: reportAlias
            };
            console.log(params);
            axios
                .post('/v2/maintenance/reports/invoice-report', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob'
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename = this.getReportFilename(
                        requestType,
                        reportAlias
                    );
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });

            /*let invoicesWithExpenses = this.report.Doc;
            let invoiceHeaders = this.reportHeaders.Doc;
            //Remove the "data-table-expand" header
            invoiceHeaders = invoiceHeaders.filter(
                header => header.value != 'data-table-expand'
            );
            //Remove the "subtotal_cost" and "total_cost" headers
            invoiceHeaders = invoiceHeaders.filter(
                header =>
                    header.value != 'subtotal_cost' &&
                    header.value != 'total_cost'
            );
            let expenseHeaders = this.expenseHeaders;
            //Merge the invoice and expense headers
            let reportHeaders = invoiceHeaders.concat(expenseHeaders);
            //Prepend the following headers to the reportHeaders: "ID", "Expense_ID"
            reportHeaders.unshift({ text: 'Expense ID', value: 'expense_id' });
            reportHeaders.unshift({ text: 'ID', value: 'id' });
            //Remove the
            let report = [];
            //Every invoice has multiple "expenses", so we need to merge the invoice and expense data, duplicate the invoice data for each expense
            invoicesWithExpenses.forEach(invoice => {
                let expenses = invoice.expenses;
                expenses.forEach(expense => {
                    //Both invoices and expenses have the same primary key name "id", so we need to rename the expense id to "expense_id"
                    expense.expense_id = expense.id;
                    delete expense.id;
                    let reportItem = Object.assign({}, invoice, expense);
                    report.push(reportItem);
                });
            });
            //Console log the first 10 reports
            console.log('Report: ', report.slice(0, 10));
            console.log('Headers: ', reportHeaders);

            sheets.generateSheet(
                report,
                'csv',
                reportHeaders,
                'Maintenance Report_[' +
                    this.dateRangeStart +
                    ' ~ ' +
                    this.dateRangeEnd +
                    ']'
            );*/
        },
        downloadAnnualSpending() {
            //Get the year from the date range
            let dateRange = this.dateRange;
            let startDate = dateRange[0];
            let year = startDate.split('-')[0];

            let type = this.invoiceType;

            let url =
                '/v2/maintenance/reports/annual-spending/' + type + '/' + year;
            axios
                .get(url)
                .then(response => {
                    console.log(response.data);
                    // xlsxSheets.getAnnualSpendingReport(response.data);
                })
                .catch(error => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Error getting report data' + error
                    });
                });
        },
        downloadAnnualSpendingByCategory() {
            //Get the year from the date range
            let dateRange = this.dateRange;
            let startDate = dateRange[0];
            let year = startDate.split('-')[0];

            let type = this.invoiceType;

            let url =
                '/v2/maintenance/reports/annual-spending/' + type + '/' + year;
            axios
                .get(url)
                .then(response => {
                    console.log(response.data);
                    xlsxSheets.getAnnualSpendingByCategoryReport(response.data);
                })
                .catch(error => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Error getting report data' + error
                    });
                });
        },
        getPurchaseOrders() {
            console.log("getPurchaseOrders", this.startDate, this.endDate);

            if (this.startDate == "" || this.endDate == "") {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date range'
                });
                return;
            }

            let str = this.$store;
            this.showTable = false;
            this.rolling12Ctx.Show = false;
            let params = {
                StartDate: this.startDate,
                EndDate: this.endDate,
            };
            str.state.isLoading = true;
            axios
                .post(
                    '/v2/maintenance/reports/purchase-orders/by-date-range', params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.purchaseOrders.Headers = response.data.Headers;
                    this.purchaseOrders.Items = response.data.Items;
                    this.purchaseOrders.Name = response.data.Name;
                    this.purchaseOrders.ReportAlias = response.data.ReportAlias;
                    this.purchaseOrders.Filename = response.data.Filename;
                    this.purchaseOrders.Show = true;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        getInvoiceReportByDateRangeByAll() {
            console.log("getInvoiceReportByDateRangeByAll", this.startDate, this.endDate);

            if (this.startDate == "" || this.endDate == "") {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date range'
                });
                return;
            }

            let str = this.$store;
            this.showTable = false;
            this.rolling12Ctx.Show = false;
            let params = {
                StartDate: this.startDate,
                EndDate: this.endDate,
            };
            str.state.isLoading = true;
            axios
                .post(
                    '/v2/maintenance/reports/invoice-report/by-date-range/all-invoices', params,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename = 'InvoiceReportByDateRangeByAll.xlsx';
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        getRolling12(report) {
            console.log(report);
            console.log("getRolling12", this.startDate, this.endDate);

            // Handle errors
            if (this.startDate == '' && this.endDate == '') {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date'
                });
                return;
            } else if (this.startDate != '' && this.endDate != '') {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select only one date'
                });
                return;
            }

            // Set params
            let params = {
                RollingDate: "",
                RollingDirection: "",
                Report: report,
            };
            if (this.startDate == '') {
                params.RollingDate = this.endDate;
                params.RollingDirection = 'FROM-END';
            } else if (this.endDate == '') {
                params.RollingDate = this.startDate;
                params.RollingDirection = 'FROM-START';
            }

            let str = this.$store;
            this.showTable = false;
            this.purchaseOrders.Show = false;
            str.state.isLoading = true;
            axios
                .post(
                    report.axios, params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    let items = response.data.Report.Items;
                    let vueheaders = response.data.Report.Headers.Vue;
                    let excelHeaders = response.data.Report.Headers.Excel;
                    let totals = response.data.Report.Totals;
                    let dateRange = response.data.DateRange;
                    // flag

                    this.resetRolling12Context();
                    switch (report.alias) {
                        case 'R12-View-By-Trailer':
                            this.rolling12Ctx.Headers = vueheaders.ByTrailer;
                            this.rolling12Ctx.Totals = totals.ByTrailer;
                            this.rolling12Ctx.CurrentView = 'ByTrailer';
                            for (let item of items) {
                                item.Details = JSON.parse(item.Details);
                            }
                            break;
                        case 'R12-View-By-Category':
                            for (let item of items) {
                                item.ByTrailer = JSON.parse(item.Trailers);
                            }
                            this.rolling12Ctx.Headers = vueheaders.ByCategory;
                            this.rolling12Ctx.Totals = totals.ByCategory;
                            this.rolling12Ctx.CurrentView = 'ByCategory';
                            break;
                        case 'R12-View-By-Region-By-Category':
                            for (let item of items) {
                                item.ByCategory = JSON.parse(item.Categories);
                                for (let cat of item.ByCategory) {
                                    if (typeof cat.Trailers === 'string') {
                                        cat.ByTrailer = JSON.parse(cat.Trailers);
                                    } else {
                                        cat.ByTrailer = cat.Trailers;
                                    }
                                }
                            }
                            this.rolling12Ctx.Headers = vueheaders.ByRegion;
                            this.rolling12Ctx.Totals = totals.ByRegion;
                            this.rolling12Ctx.CurrentView = 'ByRegion';
                            break;
                        case 'R12-View-By-Region-By-Trailer':
                            for (let item of items) {
                                item.ByTrailer = JSON.parse(item.Trailers);
                            }
                            this.rolling12Ctx.Headers = vueheaders.ByRegion;
                            this.rolling12Ctx.Totals = totals.ByRegion;
                            this.rolling12Ctx.CurrentView = 'ByRegion';
                            break;
                        case 'R12-Trailer-View-By-Trailer-By-Month':
                            for (let item of items) {
                                item.Details = JSON.parse(item.Details);
                                item.ByMonth = JSON.parse(item.Months);
                            }
                            this.rolling12Ctx.Headers = vueheaders.ByTrailer;
                            this.rolling12Ctx.Totals = totals.ByTrailer;
                            this.rolling12Ctx.CurrentView = 'ByTrailer';
                            break;
                        default:
                            break;
                    }
                    this.rolling12Ctx.MemoryTotals = totals;
                    this.rolling12Ctx.MemoryHeaders = vueheaders;
                    this.rolling12Ctx.MemoryItems = items;
                    this.rolling12Ctx.ExcelHeaders = excelHeaders;
                    this.rolling12Ctx.Items = items;
                    this.rolling12Ctx.DateRange = dateRange;
                    this.rolling12Ctx.Name = report.name;
                    this.rolling12Ctx.ReportAlias = report.alias;
                    this.rolling12Ctx.Filename = report.alias + '.xlsx';

                    console.log(this.rolling12Ctx);
                    this.rolling12Ctx.Show = true;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status == 400) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: error.response.data
                        });
                    }
                });
        },
        downloadPO() {
            let str = this.$store;
            str.state.isLoading = true;

            let params = {};
            params.Headers = this.purchaseOrders.Headers.excel;
            params.Data = this.purchaseOrders.Items;
            params.ReportAlias = this.purchaseOrders.ReportAlias;
            params.Filename = this.purchaseOrders.Filename;

            axios
                .post(
                    '/v2/maintenance/reports/generic-download', params,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename = params.Filename;
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        downloadR12() {
            let str = this.$store;
            str.state.isLoading = true;

            console.log('rolling12Ctx: ', this.rolling12Ctx);

            let params = {};
            params.Headers = this.rolling12Ctx.ExcelHeaders;
            params.Data = this.rolling12Ctx.Items.map(item => {
                if (typeof item.TotalHrsUse != 'undefined') {
                    let num = parseFloat(item.TotalHrsUse);
                    item.TotalHrsUse = Math.round(num);
                }

                if (typeof item.GeotabOdoStart != 'undefined') {
                    let num = parseFloat(item.GeotabOdoStart);
                    item.GeotabOdoStart = Math.round(num);
                }

                if (typeof item.GeotabOdoEnd != 'undefined') {
                    let num = parseFloat(item.GeotabOdoEnd);
                    item.GeotabOdoEnd = Math.round(num);
                }

                if (typeof item.OdometerKM != 'undefined') {
                    let num = parseFloat(item.OdometerKM);
                    item.OdometerKM = Math.round(num);
                }

                if (typeof item.MaintExpenses != 'undefined') {
                    let num = parseFloat(item.MaintExpenses);
                    item.MaintExpenses = Math.round(num);
                }

                if (typeof item.CostPerKM != 'undefined') {
                    let num = parseFloat(item.CostPerKM);
                    item.CostPerKM = num.toFixed(4);
                }

                return item;
            });

            if (this.rolling12Ctx.Totals.length) {
                params.Totals = {};
                for (let total of this.rolling12Ctx.Totals) {
                    if (total == 'CostPerKM') {
                        params.Totals[total] = this.getCostPerKM(false);
                    } else {
                        params.Totals[total] = this.getTotalByField(this.rolling12Ctx.Items, total, '', 0);
                    }
                }
            }
            params.ReportAlias = this.rolling12Ctx.ReportAlias;
            params.Filename = this.rolling12Ctx.Filename;

            console.log('Params ', params);
            axios
                .post(
                    '/v2/maintenance/reports/generic-download', params,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename = params.Filename;
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        getCurrentView(view) {
            return this.rolling12Ctx.CurrentView == view;
        },
        getReportAlias(alias, isEqualTo = false) {
            if (isEqualTo) {
                return this.rolling12Ctx.ReportAlias === alias;
            } else {
                return this.rolling12Ctx.ReportAlias !== alias;
            }
        },
        goToInvoiceAnalysis(item) {
            console.log("Item: ", item);

            const query = {
                invoiceType: "trailers",
                equipmentId: item.TrailerId,
                odometerKM: item.OdometerKM,
                startDate: this.rolling12Ctx.DateRange.From,
                endDate: this.rolling12Ctx.DateRange.To,
                regionId: this.rolling12Ctx.RegionId,
                externalSource: true,
            };

            const queryString = Object.keys(query)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
                .join('&');
            console.log("queryString", queryString);

            const url = `${this.$router.resolve({
                    name: 'InvoiceAnalysis',
                }).href}?${queryString}`;

            window.open(url, '_blank');
        },
        handleNextLevel(item) {
            this.rolling12Ctx.LastItems = this.rolling12Ctx.Items;
            switch (this.rolling12Ctx.ReportAlias) {
                case 'R12-View-By-Category':
                    if (this.rolling12Ctx.CurrentView == 'ByCategory') {
                        console.log('1');
                        this.rolling12Ctx.Items = item.ByTrailer;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByTrailer;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByTrailer;
                        this.rolling12Ctx.CurrentView = 'ByTrailer';
                        this.rolling12Ctx.CurrentPath = item.Category + ' / ';
                    }
                    break;
                case 'R12-View-By-Region-By-Category':
                    if (this.rolling12Ctx.CurrentView == 'ByRegion') {
                        console.log('2');
                        this.rolling12Ctx.Items = item.ByCategory;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByCategory;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByCategory;
                        this.rolling12Ctx.CurrentView = 'ByCategory';
                        this.rolling12Ctx.RegionId = item.RegionId;
                        this.rolling12Ctx.CurrentPath = item.Region + ' / ';
                    } else if (this.rolling12Ctx.CurrentView == 'ByCategory') {
                        console.log('3');
                        this.rolling12Ctx.Items = item.ByTrailer;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByTrailer;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByTrailer;
                        this.rolling12Ctx.CurrentView = 'ByTrailer';
                        this.rolling12Ctx.CurrentPath += item.Category + ' / ';
                    }
                    break;
                case 'R12-View-By-Region-By-Trailer':
                    if (this.rolling12Ctx.CurrentView == 'ByRegion') {
                        console.log('4');
                        this.rolling12Ctx.Items = item.ByTrailer;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByTrailer;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByTrailer;
                        this.rolling12Ctx.CurrentView = 'ByTrailer';
                        this.rolling12Ctx.RegionId = item.RegionId;
                        this.rolling12Ctx.CurrentPath = item.Region + ' / ';
                    }
                    break;
                case 'R12-Trailer-View-By-Trailer-By-Month':
                    if (this.rolling12Ctx.CurrentView == 'ByTrailer') {
                        console.log('5');
                        this.rolling12Ctx.Items = item.ByMonth;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByMonth;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByMonth;
                        this.rolling12Ctx.CurrentView = 'ByMonth';
                        this.rolling12Ctx.CurrentPath = item.Trailer + ' / ';
                    }
                    break;
                default:
                    break;
            }
            console.log(this.rolling12Ctx);
        },
        handlePreviousLevel() {
            switch (this.rolling12Ctx.ReportAlias) {
                case 'R12-View-By-Category':
                    if (this.rolling12Ctx.CurrentView == 'ByTrailer') {
                        console.log('5');
                        this.rolling12Ctx.Items = this.rolling12Ctx.LastItems;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByCategory;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByCategory;
                        this.rolling12Ctx.CurrentView = 'ByCategory';
                        this.rolling12Ctx.LastItems = [];
                        this.rolling12Ctx.CurrentPath = '';
                    }
                    break;
                case 'R12-View-By-Region-By-Category':
                    if (this.rolling12Ctx.CurrentView == 'ByCategory') {
                        console.log('6');
                        this.rolling12Ctx.Items = this.rolling12Ctx.MemoryItems;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByRegion;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByRegion;
                        this.rolling12Ctx.CurrentView = 'ByRegion';
                        this.rolling12Ctx.LastItems = [];
                        this.rolling12Ctx.CurrentPath = '';
                    } else if (this.rolling12Ctx.CurrentView == 'ByTrailer') {
                        console.log('7');
                        this.rolling12Ctx.Items = this.rolling12Ctx.LastItems;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByCategory;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByCategory;
                        this.rolling12Ctx.CurrentView = 'ByCategory';
                        let parts = this.rolling12Ctx.CurrentPath.split(' / ');
                        this.rolling12Ctx.CurrentPath = parts[0];
                    }
                    break;
                case 'R12-View-By-Region-By-Trailer':
                    if (this.rolling12Ctx.CurrentView == 'ByTrailer') {
                        console.log('8');
                        this.rolling12Ctx.Items = this.rolling12Ctx.LastItems;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByRegion;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByRegion;
                        this.rolling12Ctx.CurrentView = 'ByRegion';
                        this.rolling12Ctx.LastItems = [];
                        this.rolling12Ctx.CurrentPath = '';
                    }
                    break;
                case 'R12-Trailer-View-By-Trailer-By-Month':
                    if (this.rolling12Ctx.CurrentView == 'ByMonth') {
                        console.log('9');
                        this.rolling12Ctx.Items = this.rolling12Ctx.LastItems;
                        this.rolling12Ctx.Headers = this.rolling12Ctx.MemoryHeaders.ByTrailer;
                        this.rolling12Ctx.Totals = this.rolling12Ctx.MemoryTotals.ByTrailer;
                        this.rolling12Ctx.CurrentView = 'ByTrailer';
                        this.rolling12Ctx.LastItems = [];
                        this.rolling12Ctx.CurrentPath = '';
                    }
                    break;
                default:
                    break;
            }
            console.log(this.rolling12Ctx);
        },
        resetRolling12Context() {
            this.rolling12Ctx = {
                Show: false,
                Items: [],
                Headers: [],
                Totals: [],
                DateRange: [],
                CurrentView: '',
                MemoryHeaders: [],
                MemoryTotals: [],
                MemoryItems: [],
                LastItems: [],
                ExcelHeaders: [],
                ReportAlias: '',
                Name: '',
                Filename: '',
                RegionId: '',
                CurrentPath: '',
            };
        },
        copyToClipboard(strings) {
            let text = strings.join('\n');
            navigator.clipboard.writeText(text);
            this.$store.dispatch('setSnackbar', {
                text: 'Successfully copied to clipboard!',
                color: 'success'
            });
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Maintenance Reports';
            }
        },
        startDate() {
            if (this.startDate != '' && this.endDate != '') {
                this.getDateRangeTotalCost();
            }
        },
        endDate() {
            if (this.startDate != '' && this.endDate != '') {
                this.getDateRangeTotalCost();
            }
        },
        dateRange() {
            this.setDateRange();
            if (this.dateRange.length == 2) {
                this.getDateRangeTotalCost();
            }
        }
    }
};
</script>
